import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Loading } from "../../../components/Loading/Loading";
import { Toast } from "primereact/toast";
// import { FooterButtonCenter } from "../../../components/FooterButton/FooterButton"; //FooterButton,
import { dataUserSession } from "../../../utilities/dataSession";
import P301Overview from "./P301Overview";
import P301List from "./P301List";
import P301Search from "./P301Search";
import { P301DashboardList, P301GetDataChart_1, P301GetDataChart_2, P301GetDataChart_3 } from "../../../service/300/P301Service";
import "../../../components/DataTable/DataTable.css";
import P301Map from "./P301Map";
import P301Chart from "./P301Chart";
import { genBudgetTypeList } from "../../../service/GEN/GenService";
import ValidateService from "../../../components/ValidateService/ValidateService";
import P301Chart2 from "./P301Chart2";
import P301Chart3 from "./P301Chart3";
import { Button } from "primereact/button";

export default function P301() {
    const history = useHistory();
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);

    const [checkRole, setCheckRole] = useState(true);
    //Dashboard
    const [dataDashboard, setDataDashboard] = useState({
        totalContract: 0,
        totalPipeLength: 0,
        totalAmount: 0,
        pendingAmount: 0,
    });
    //DataTable
    const [dataTable, setDataTable] = useState([]);
    const [branchCode, setBranchCode] = useState(dataUserSession() ? dataUserSession().userBranchCode : "");
    const [searchData, setSearchData] = useState({
        branchCode: branchCode,
        budgetType: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    const [dataGenList, setDataGenList] = useState([]);
    const [sentGen, setSentGen] = useState({
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    const [sentChart, setSentChart] = useState({
        branchCode: branchCode,
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    const [dataChart1, setDataChart1] = useState({
        seriesList: [],
        valList1: [],
        valList2: [],
    });
    const [dataChart2, setDataChart2] = useState({
        seriesList: [],
        valList1: [],
        valList2: [],
    });
    const [dataChart3, setDataChart3] = useState({
        seriesList: [],
        valList1: [],
        valList2: [],
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (dataUserSession()) {
            let userRole = dataUserSession().userRole;
            if (userRole === "3" || userRole === "A") {
                setCheckRole(false);
            }

            if (history.location.state) {
                setSearchData({
                    ...searchData,
                    ...history.location.state,
                });

                setSentChart({
                    ...sentChart,
                    ...history.location.state,
                });

                setBranchCode(history.location.state.branchCode);
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        // console.log('searchData ',searchData);
        onP301DashboardList();
        onGenBudgetTypeList();
    }, [searchData]);

    useEffect(() => {
        // console.log('sentChart ',sentChart);
        onP301GetDataChart_1();
        onP301GetDataChart_2();
        onP301GetDataChart_3();
    }, [sentChart]);

    const onP301DashboardList = () => {
        P301DashboardList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        if (index === 1) {
                            setDataDashboard({
                                totalContract: element.totalContract,
                                totalPipeLength: element.totalPipeLength,
                                totalAmount: element.totalAmount,
                                pendingWithdraw: element.pendingWithdraw,
                            });
                        }

                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onGenBudgetTypeList = () => {
        genBudgetTypeList(sentGen).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    temp.push({ index: 0, budgetTypeCode: "", budgetTypeDesc: "เลือก" });
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });

                    setDataGenList(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP301GetDataChart_1 = () => {
        setLoading(true);
        P301GetDataChart_1(sentChart).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let seriesList = [];
                    let valList1 = [];
                    let valList2 = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        seriesList.push(element.contractNo);
                        valList1.push(element.contractAmount);
                        valList2.push(element.operateAmount);

                        index++;
                    });
                    setDataChart1({ data: temp, seriesList, valList1, valList2 });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP301GetDataChart_2 = () => {
        setLoading(true);
        P301GetDataChart_2(sentChart).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let seriesList = [];
                    let valList1 = [];
                    let valList2 = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        seriesList.push(element.dateSeries);
                        valList1.push(element.planAmount);
                        valList2.push(element.actualAmount);

                        index++;
                    });
                    setDataChart2({ data: temp, seriesList, valList1, valList2 });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP301GetDataChart_3 = () => {
        setLoading(true);
        P301GetDataChart_3(sentChart).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let seriesList = [];
                    let valList1 = [];
                    let valList2 = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        seriesList.push(element.dateSeries);
                        valList1.push(element.planAmount);
                        valList2.push(element.actualAmount);

                        index++;
                    });
                    setDataChart3({ data: temp, seriesList, valList1, valList2 });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onRowClick = (e) => {
        if (e && e.data) {
            history.push({
                pathname: "302",
                state: {
                    contractNo: e.data.contractNo,
                    branchCode: branchCode,
                },
            });
        }
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-grid  p-fluid">
                            <div className="p-field p-col-12 p-md-6">
                                {checkRole === true ? (
                                    <Button
                                        className="p-button-secondary p-button btn-long-top-responsive"
                                        icon="pi pi-arrow-left"
                                        label="กลับหน้าจอหลัก"
                                        // style={{ display: 'flex',marginBottom : '10px' }}
                                        style={{ width: 170, marginLeft: "5px" }}
                                        onClick={() => {
                                            history.push("/300");
                                        }}
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                        <P301Overview dataDashboard={dataDashboard} />
                        <br />

                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-12">
                                <div className="card">
                                    <div className="p-grid  p-fluid">
                                        <P301Map data={searchData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="p-grid  p-fluid">
                            {/* <div className="p-col-12 p-md-4"> */}
                            <div className="p-col-12 p-md-12">
                                <P301Search dataList={dataGenList} data={searchData} setData={setSearchData} setDataChart={setSentChart} />
                            </div>
                        </div>
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-12">
                                <div className="card">
                                    <P301List dataTable={dataTable} onRowClick={onRowClick} />
                                </div>
                            </div>
                        </div>
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-lg-1"></div>
                            <div className="p-col-12 p-lg-10">
                                <div className="card">
                                    <P301Chart data={dataChart1} />
                                </div>
                            </div>
                            <div className="p-col-12 p-lg-1"></div>
                        </div>

                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-lg-1"></div>
                            <div className="p-col-12 p-lg-10">
                                <div className="card">
                                    <P301Chart2 data={dataChart2} />
                                </div>
                            </div>
                            <div className="p-col-12 p-lg-1"></div>
                        </div>

                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-lg-1"></div>
                            <div className="p-col-12 p-lg-10">
                                <div className="card">
                                    <P301Chart3 data={dataChart3} />
                                </div>
                            </div>
                            <div className="p-col-12 p-lg-1"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
